import React from "react"
import { graphql } from "gatsby"

import { makeStyles } from '@material-ui/styles';
import { ThemeProvider } from '@material-ui/styles';

import defaultTheme from "src/styles/theme";

import PostPage from "../components/post/PostPage"
import Layout   from "src/components/layout/layout"
import SEO from "../components/seo"

import "../styles/index.scss"
import pattern from "src/images/pattern.png"
// import "../styles/fontawesome/scss/fontawesome.scss";

const useStyles = makeStyles(theme => ({
  background: {
    ...defaultTheme.flex.row,
    ...defaultTheme.flex.justifyCenter,
    width: '100%',
    // background: defaultTheme.base.colors.background,
    background: `url(${pattern})`,
  },
  pageWrap: {
    ...defaultTheme.flex.col,
    ...defaultTheme.contentWrap,
  }
}));


export default function BlogPostTemplate(props) {

  const { data } = props
  const classes = useStyles()
  const siteTitle = data.site.siteMetadata.title
  const post = data.markdownRemark

  return (
    <ThemeProvider theme={defaultTheme}>
      <Layout location={props.location} title={siteTitle}>
        <SEO
          title={post.frontmatter.title}
          subTitle={post.frontmatter.subTitle || post.excerpt}
        />
        <div className={classes.background}>
          <div className={classes.pageWrap}>
            <PostPage 
              post={post} 
              pageContext={props.pageContext}
            />
          </div>
        </div>
      </Layout>
    </ThemeProvider>
  )
}

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    site {
      siteMetadata {
        title
        author
      }
    }
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      excerpt(pruneLength: 160)
      html
      frontmatter {
        title
        subTitle,
        tags,
        date(formatString: "YYYY. MM. DD"),
        
      }
    }
  }
`

// featuredImage {
//   childImageSharp {
//     fluid(maxWidth: 800) {
//       ...GatsbyImageSharpFluid
//     }
//   }
// }

